import forge from 'node-forge';
export const encryptRSA = async (password: string): Promise<string> => {
    const PUBLIC_KEY = await fetchPublicKey();
    const publicKey = forge.pki.publicKeyFromPem(PUBLIC_KEY);
    const encrypted = publicKey.encrypt(password, 'RSA-OAEP');
    return forge.util.encode64(encrypted);
}

export async function fetchPublicKey(): Promise<string> {
    const res = await fetch('/public_key.pem', { cache: 'no-cache' });
    return await res.text();
}